import { api } from "../api";
import {
  DiaryAdminResponse,
  AttendanceAdminResponse,
  DiaryTeacherFilters,
  School,
  Grade,
} from "./diary-teacher.types";

export const diaryTeacherAdminApi = {
  // Obtener registros del diario
  getDiaryRecords: async (filters: DiaryTeacherFilters): Promise<DiaryAdminResponse> => {
    try {
      const params = new URLSearchParams();

      if (filters.schoolId) params.append("schoolId", filters.schoolId.toString());
      if (filters.gradeId) params.append("gradeId", filters.gradeId.toString());
      if (filters.startDate) params.append("startDate", filters.startDate);
      if (filters.endDate) params.append("endDate", filters.endDate);
      if (filters.week) params.append("week", filters.week.toString());
      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.sortBy) params.append("sortBy", filters.sortBy);
      if (filters.sortDirection) params.append("sortDirection", filters.sortDirection);

      const response = await api.get(
        `/admin/diary-teacher/diary-records?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching diary records:", error);
      throw error;
    }
  },

  // Obtener registros de asistencia
  getAttendanceRecords: async (filters: DiaryTeacherFilters): Promise<AttendanceAdminResponse> => {
    try {
      const params = new URLSearchParams();

      if (filters.schoolId) params.append("schoolId", filters.schoolId.toString());
      if (filters.gradeId) params.append("gradeId", filters.gradeId.toString());
      if (filters.startDate) params.append("startDate", filters.startDate);
      if (filters.endDate) params.append("endDate", filters.endDate);
      if (filters.week) params.append("week", filters.week.toString());
      if (filters.page) params.append("page", filters.page.toString());
      if (filters.limit) params.append("limit", filters.limit.toString());
      if (filters.sortBy) params.append("sortBy", filters.sortBy);
      if (filters.sortDirection) params.append("sortDirection", filters.sortDirection);

      const response = await api.get(
        `/admin/diary-teacher/attendance-records?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching attendance records:", error);
      throw error;
    }
  },

  // Obtener escuelas
  getSchools: async (): Promise<School[]> => {
    try {
      const response = await api.get("/admin/diary-teacher/schools");

      return response.data;
    } catch (error) {
      console.error("Error fetching schools:", error);
      throw error;
    }
  },

  // Obtener grados
  getGrades: async (schoolId?: number): Promise<Grade[]> => {
    try {
      const params = new URLSearchParams();
      if (schoolId) params.append("schoolId", schoolId.toString());

      const response = await api.get(
        `/admin/diary-teacher/grades?${params.toString()}`
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching grades:", error);
      throw error;
    }
  },

  // Obtener semanas disponibles
  getWeeks: async (): Promise<{ id: number; name: string }[]> => {
    try {
      const response = await api.get("/admin/diary-teacher/weeks");

      return response.data;
    } catch (error) {
      console.error("Error fetching weeks:", error);
      throw error;
    }
  },
};
